<!-- ToggleSwitch.vue -->
<template>
  <label class="switch">
    <input type="checkbox" :checked="modelValue" @change="toggle">
    <span class="slider"></span>
  </label>
</template>

<script setup>
const props = defineProps({
  modelValue: { type: Boolean, required: true }
})

const emit = defineEmits(['update:modelValue'])

const toggle = () => {
  emit('update:modelValue', !props.modelValue)
}
</script>

<style scoped>
.switch {
  position: relative;
  display: inline-block;
  width: 25px;    /* 50px → 25px */
  height: 14px;   /* 28px → 14px */
}

.switch input {
  opacity: 0;
  width: 0;
  height: 0;
}

.slider {
  position: absolute;
  cursor: pointer;
  top: 0; left: 0;
  right: 0; bottom: 0;
  background-color: #ccc;
  transition: 0.4s;
  border-radius: 17px; /* 34px → 17px */
}

.slider:before {
  position: absolute;
  content: "";
  height: 11px;   /* 22px → 11px */
  width: 11px;    /* 22px → 11px */
  left: 1.5px;    /* 3px → 1.5px */
  top: 50%;
  transform: translateY(-50%);
  background-color: #000000;
  transition: 0.4s;
  border-radius: 50%;
}

input:checked + .slider {
  background-color: #FFD353;
}

input:checked + .slider:before {
  transform: translate(11px, -50%);
}
</style>
